import { Sheet } from "@silk-hq/components"
import PropTypes from "prop-types"
import React from "react"

const Root = ({ children, open, onOpenChange, ...props }) => {
  return (
    <Sheet.Root
      presented={open}
      onPresentedChange={onOpenChange}
      license="commercial"
      {...props}
    >
      {children}
    </Sheet.Root>
  )
}

Root.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
}

const Trigger = ({ children, asChild = true, ...props }) => {
  return (
    <Sheet.Trigger asChild={asChild} {...props}>
      {children}
    </Sheet.Trigger>
  )
}

Trigger.propTypes = {
  children: PropTypes.node.isRequired,
  asChild: PropTypes.bool,
}

const Content = ({ children, ...props }) => {
  return (
    <Sheet.Portal>
      <Sheet.View
        className="z-modal"
        contentPlacement="bottom"
        swipeDismissal
        onClickOutside={{ dismiss: true }}
        onEscapeKeyDown={{ dismiss: true }}
      >
        <Sheet.Backdrop className="fixed inset-0 bg-black/50" />
        <Sheet.Content
          className="rounded-t-2xl bg-white p-4"
          style={{ height: "fit-content", maxHeight: "90vh" }}
          {...props}
        >
          {children}
        </Sheet.Content>
      </Sheet.View>
    </Sheet.Portal>
  )
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
}

const Handle = ({ children = "Drag to resize", ...props }) => {
  return (
    <Sheet.Handle
      className="mx-auto mb-4 flex w-12 items-center justify-center"
      {...props}
    >
      <div className="h-1 w-10 rounded-full bg-gray-300" />
      {children}
    </Sheet.Handle>
  )
}

Handle.propTypes = {
  children: PropTypes.node,
}

const BottomSheet = {
  Root,
  Trigger,
  Content,
  Handle,
}

export default BottomSheet
